module.exports = __webpack_public_path__ + "img/kl-logo-small.c8c91a2.svg";